import Icon from '@/components/UI/Icon';
import Tooltip from '@/components/UI/Tooltip';
import type { ID } from '@/model/Common.model';
import { type FC } from 'react';

interface TableActionButtonsProps {
  itemId: ID;
  isEditing: boolean;
  isEditable: boolean;
  isSaving?: boolean;
  onEdit: (itemId: ID) => void;
  onSave: (itemId: ID) => void;
  onCancel: (itemId: ID) => void;
  testIdPrefix?: string;
}

export const TableActionButtons: FC<TableActionButtonsProps> = ({
  itemId,
  isEditing,
  isEditable,
  isSaving = false,
  onEdit,
  onSave,
  onCancel,
  testIdPrefix = 'field',
}) => {
  if (!isEditable) {
    return <div className="ml3 spacer-26"></div>;
  } else if (isEditing) {
    return (
      <>
        <div
          className="ml3 pointer flex items-center"
          onClick={() => onCancel(itemId)}
          data-testid={`cancel-button-${testIdPrefix}`}
        >
          <Tooltip render="Cancel changes">
            <Icon icon="close" width="12" height="12" className="dark-gray hover-red" />
          </Tooltip>
        </div>
        <div
          className="ml2 pointer flex items-center"
          onClick={() => onSave(itemId)}
          data-testid={`save-button-${testIdPrefix}`}
        >
          <Tooltip render={isSaving ? 'Saving...' : 'Save changes'}>
            <Icon icon="checkbox" width="16" height="16" className={isSaving ? 'dark-gray' : 'dark-gray hover-blue'} />
          </Tooltip>
        </div>
      </>
    );
  }

  return (
    <div
      className="ml3 pointer flex items-center"
      onClick={() => onEdit(itemId)}
      data-testid={`edit-button-${testIdPrefix}`}
    >
      <Tooltip render="Edit field">
        <Icon icon="pencil" width="24" height="24" className="hover-near-black dark-gray" />
      </Tooltip>
    </div>
  );
};
